import { CurrenciesInterface } from '../interfaces/deposit.interface';
import { CurrencyBalance } from '../interfaces/wallet.interface';

/**
 * 已存款且未 KYC 玩家預設幣種：依 getUserbalance 回傳順序，優先取有餘額且商戶可見的幣種；
 * 若皆無餘額則取第一個可見幣種；userSetting.defaultCurrencyType 僅作最後 fallback。
 *
 * @param balances getUserbalance 回傳的錢包幣種列表
 * @param preferredCode userSetting.defaultCurrencyType，作為 fallback 候選
 * @param visibleCurrencies 商戶可見幣種列表
 * @returns 解析後的預設幣種代碼，無匹配則 null
 */
export function resolveDepositedDefaultCurrency(
  balances: CurrencyBalance[],
  preferredCode: string | undefined,
  visibleCurrencies: CurrenciesInterface[],
): string | null {
  const visibleCodes = new Set(visibleCurrencies.filter(c => c.isVisible).map(c => c.currency));
  const walletCodes = new Set(balances.map(b => b.currency));

  const withBalance = balances.find(b => visibleCodes.has(b.currency) && b.balance > 0);
  if (withBalance) return withBalance.currency;

  const depositedCurrency = balances.find(b => visibleCodes.has(b.currency));
  if (depositedCurrency) return depositedCurrency.currency;

  const preferredCurrency =
    preferredCode && visibleCodes.has(preferredCode) && walletCodes.has(preferredCode) ? preferredCode : null;

  return preferredCurrency;
}
